
const style = (theme) => {
  const output = {
    root: {
      minHeight: '100vh',
      background: theme.colors[8],
      color: theme.colors[1],
    },
    content: {
      background: theme.colors[1],
      color: theme.colors[0],
    },
    wrapper: {
      extend: theme.wrapper,
    },
    intro: {
      paddingTop: 100,
      paddingBottom: 100,
    },
    additionalText: {
      '& .TextBlock__title': {
        fontSize: 16,
      },
      '& .TextBlock__text': {
        fontSize: 16,
      },
    },
    gallery: {
      marginBottom: 100,
    },
    listView: {
      marginTop: 200,
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {

  }

  return output
}

export default style
